function calculatePercentage(number1, number2) {
  if (!number1 || !number2) {
    return 0;
  }

  return parseFloat(((number1 / number2) * 100).toFixed(2));
}

export default calculatePercentage;
